var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "app-container" },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "justify-content": "end" } },
            [
              !_vm.showFilter
                ? _c(
                    "div",
                    [
                      _c("a-input", {
                        staticStyle: { width: "200px", "margin-right": "1rem" },
                        attrs: {
                          placeholder: _vm.placeholderMsg,
                          clearable: "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.queryByPage()
                          },
                        },
                        model: {
                          value: _vm.queryCondition.applyOrderCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryCondition, "applyOrderCode", $$v)
                          },
                          expression: "queryCondition.applyOrderCode",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                [
                  !_vm.showFilter
                    ? _c(
                        "vxe-button",
                        {
                          attrs: { status: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.handSearch()
                            },
                          },
                        },
                        [_vm._v("搜索")]
                      )
                    : _vm._e(),
                  !_vm.showFilter
                    ? _c(
                        "vxe-button",
                        {
                          staticClass: "filter-search-item",
                          on: { click: _vm.resetForm },
                        },
                        [_vm._v("重置")]
                      )
                    : _vm._e(),
                  _c("vxe-button", { on: { click: _vm.cb } }, [
                    _vm._v(
                      " " + _vm._s(_vm.showFilter ? "收起" : "更多选项") + " "
                    ),
                  ]),
                ],
                1
              ),
            ]
          ),
          _c("div", [
            _vm.showFilter
              ? _c(
                  "div",
                  [
                    _c("br"),
                    _c(
                      "a-form",
                      {
                        staticClass: "SiftActivity UniformCss",
                        attrs: { "label-width": "110px" },
                      },
                      [
                        _c(
                          "a-row",
                          [
                            _c(
                              "a-col",
                              { attrs: { span: 4 } },
                              [
                                _c(
                                  "a-form-item",
                                  { attrs: { label: "订单编号：" } },
                                  [
                                    _c("a-input", {
                                      attrs: { clearable: "" },
                                      model: {
                                        value:
                                          _vm.queryCondition.applyOrderCode,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "applyOrderCode",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryCondition.applyOrderCode",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "a-col",
                              { attrs: { span: 4 } },
                              [
                                _c(
                                  "a-form-item",
                                  { attrs: { label: "申领部门：" } },
                                  [
                                    _c("a-input", {
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.queryCondition.orgName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "orgName",
                                            $$v
                                          )
                                        },
                                        expression: "queryCondition.orgName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "a-col",
                              { attrs: { span: 4 } },
                              [
                                _c(
                                  "a-form-item",
                                  { attrs: { label: "申领人：" } },
                                  [
                                    _c("a-input", {
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.queryCondition.applyMan,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "applyMan",
                                            $$v
                                          )
                                        },
                                        expression: "queryCondition.applyMan",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "a-col",
                              { attrs: { span: 4 } },
                              [
                                _c(
                                  "a-form-item",
                                  { attrs: { label: "申领日期：" } },
                                  [
                                    _c("a-date-picker", {
                                      attrs: {
                                        valueFormat: "YYYY-MM-DD",
                                        picker: "date",
                                        placeholder: "选择日期",
                                      },
                                      model: {
                                        value:
                                          _vm.queryCondition.beginApplyTime,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "beginApplyTime",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryCondition.beginApplyTime",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "a-col",
                              { attrs: { span: 4 } },
                              [
                                _c(
                                  "a-form-item",
                                  { attrs: { label: "至：" } },
                                  [
                                    _c("a-date-picker", {
                                      attrs: {
                                        valueFormat: "YYYY-MM-DD",
                                        picker: "date",
                                        placeholder: "选择日期",
                                        "picker-options": {
                                          disabledDate: function (time) {
                                            return (
                                              time.getTime() <
                                              new Date(
                                                _vm.queryCondition.beginApplyTime
                                              ) -
                                                8.64e7
                                            )
                                          },
                                        },
                                      },
                                      model: {
                                        value: _vm.queryCondition.endApplyTime,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "endApplyTime",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryCondition.endApplyTime",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "center",
                          "padding-bottom": "10px",
                        },
                        attrs: { slot: "footer" },
                        slot: "footer",
                      },
                      [
                        _c(
                          "vxe-button",
                          {
                            staticClass: "filter-search-item",
                            on: { click: _vm.resetForm },
                          },
                          [_vm._v("重置")]
                        ),
                        _c(
                          "vxe-button",
                          {
                            attrs: { status: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.handSearch()
                              },
                            },
                          },
                          [_vm._v("搜索")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c(
            "el-tabs",
            {
              staticClass: "tabsClass",
              on: { "tab-click": _vm.resetForm },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "待办事项", name: "first" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        background: "#F3F4F7",
                        display: "flex",
                        "align-items": "center",
                        gap: "8px",
                      },
                    },
                    [
                      _c(
                        "vxe-button",
                        {
                          directives: [
                            {
                              name: "auth",
                              rawName: "v-auth",
                              value: "BATCHAPPROVEINMATERIAL",
                              expression: "`BATCHAPPROVEINMATERIAL`",
                            },
                          ],
                          staticStyle: { "margin-left": "10px" },
                          attrs: { status: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.batchApproveDialogVisible = true
                            },
                          },
                        },
                        [_vm._v(" 批量审批 ")]
                      ),
                      _c("vxe-toolbar", {
                        ref: "toolbarRef",
                        staticStyle: {
                          flex: "1",
                          height: "43px",
                          background: "#F3F4F7",
                        },
                        attrs: { custom: "" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "vxe-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.listLoading,
                          expression: "listLoading",
                        },
                      ],
                      ref: "xTable",
                      staticClass: "mytable-scrollbar",
                      attrs: {
                        id: "toolbar_undoList",
                        align: _vm.allAlign,
                        "max-height":
                          _vm.$store.state.app.height - 130 < 500
                            ? 500
                            : _vm.$store.state.app.height - 130,
                        border: "",
                        "show-header-overflow": "",
                        "show-overflow": "",
                        "column-config": { resizable: true },
                        "custom-config": {
                          storage: true,
                          checkMethod: _vm.checkColumnMethod,
                        },
                        stripe: "",
                        round: "",
                        "sort-config": { remote: true },
                        "scroll-y": { enabled: false },
                        "row-config": { isCurrent: true, isHover: true },
                        data: _vm.tableData,
                      },
                      on: {
                        "sort-change": _vm.listSortMethod,
                        "cell-dblclick": _vm.cellClickEvent,
                      },
                    },
                    [
                      _c("vxe-column", {
                        attrs: {
                          type: "checkbox",
                          width: "60",
                          align: "center",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          type: "seq",
                          title: "序号",
                          width: "60",
                          align: "center",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "applyOrderCode",
                          title: "订单编号",
                          width: "130",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "orgName",
                          title: " 申领部门",
                          width: "150",
                          align: "center",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "applyMan",
                          title: "申领人",
                          width: "130",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "applyTime",
                          title: "申领日期",
                          width: "130",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "receiverName",
                          title: "收货人",
                          width: "130",
                          align: "center",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "receivePhone",
                          title: "收货人联系方式",
                          width: "140",
                          align: "center",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "orderStatus",
                          title: "订单状态",
                          width: "120",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          title: "操作",
                          field: "address",
                          fixed: "right",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _c(
                                  "div",
                                  { staticClass: "operate" },
                                  [
                                    _c(
                                      "a-button",
                                      {
                                        directives: [
                                          {
                                            name: "auth",
                                            rawName: "v-auth",
                                            value: "VIEW",
                                            expression: "`VIEW`",
                                          },
                                        ],
                                        attrs: {
                                          size: "small",
                                          type: "link",
                                          status: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.viewDetail(row, "1")
                                          },
                                        },
                                      },
                                      [_vm._v("审核")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c("vxe-pager", {
                    attrs: {
                      "current-page": _vm.pagination.current,
                      "page-size": _vm.pagination.size,
                      total: _vm.pagination.total,
                      layouts: [
                        "PrevPage",
                        "JumpNumber",
                        "NextPage",
                        "FullJump",
                        "Sizes",
                        "Total",
                      ],
                    },
                    on: { "page-change": _vm.changePage },
                  }),
                  _c("vxe-modal", {
                    attrs: {
                      title: "查看详情",
                      width: "600",
                      height: "400",
                      mask: false,
                      "lock-view": false,
                      resize: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function () {
                          return [
                            _c(
                              "vxe-table",
                              {
                                attrs: {
                                  border: "inner",
                                  "auto-resize": "",
                                  "show-overflow": "",
                                  height: "auto",
                                  "row-config": { isHover: true },
                                  "show-header": false,
                                  "sync-resize": _vm.showDetails,
                                  data: _vm.detailData,
                                },
                              },
                              [
                                _c("vxe-column", {
                                  attrs: { field: "label", width: "40%" },
                                }),
                                _c("vxe-column", { attrs: { field: "value" } }),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.showDetails,
                      callback: function ($$v) {
                        _vm.showDetails = $$v
                      },
                      expression: "showDetails",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "已办事项", name: "second" } },
                [
                  _c(
                    "vxe-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.listLoading2,
                          expression: "listLoading2",
                        },
                      ],
                      ref: "xTable2",
                      staticClass: "mytable-scrollbar",
                      attrs: {
                        align: _vm.allAlign,
                        "max-height":
                          _vm.$store.state.app.height - 130 < 500
                            ? 500
                            : _vm.$store.state.app.height - 130,
                        border: "",
                        "show-header-overflow": "",
                        "show-overflow": "",
                        "column-config": { resizable: true },
                        stripe: "",
                        round: "",
                        "sort-config": { remote: true },
                        "scroll-y": { enabled: false },
                        "row-config": { isHover: true },
                        data: _vm.tableData2,
                      },
                      on: { "sort-change": _vm.listSortMethod },
                    },
                    [
                      _c("vxe-column", {
                        attrs: {
                          type: "checkbox",
                          width: "60",
                          align: "center",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          type: "seq",
                          title: "序号",
                          width: "60",
                          align: "center",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "applyOrderCode",
                          title: "订单编号",
                          width: "130",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "orgName",
                          title: " 申领部门",
                          width: "150",
                          align: "center",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "applyMan",
                          title: "申领人",
                          width: "130",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "applyTime",
                          title: "申领日期",
                          width: "130",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "receiverName",
                          title: "收货人",
                          width: "130",
                          align: "center",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "receivePhone",
                          title: "收货人联系方式",
                          width: "140",
                          align: "center",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "orderStatus",
                          title: "订单状态",
                          width: "120",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          title: "操作",
                          fixed: "right",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                _c(
                                  "div",
                                  { staticClass: "operate" },
                                  [
                                    _c(
                                      "a-button",
                                      {
                                        directives: [
                                          {
                                            name: "auth",
                                            rawName: "v-auth",
                                            value: "VIEW",
                                            expression: "`VIEW`",
                                          },
                                        ],
                                        attrs: {
                                          size: "small",
                                          type: "link",
                                          status: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.viewDetail(row, "2")
                                          },
                                        },
                                      },
                                      [_vm._v("查看")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c("vxe-pager", {
                    attrs: {
                      "current-page": _vm.pagination2.current,
                      "page-size": _vm.pagination2.size,
                      total: _vm.pagination2.total,
                      layouts: [
                        "PrevPage",
                        "JumpNumber",
                        "NextPage",
                        "FullJump",
                        "Sizes",
                        "Total",
                      ],
                    },
                    on: { "page-change": _vm.changePage2 },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "审批信息",
            visible: _vm.taskDialogVisible,
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.taskDialogVisible = $event
            },
          },
        },
        [
          _c(
            "vxe-table",
            {
              ref: "xApprove",
              attrs: {
                border: "",
                "show-header-overflow": "",
                "show-overflow": "",
                "column-config": { resizable: true },
                stripe: "",
                round: "",
                loading: _vm.approveLoading,
                "max-height": "370",
                align: _vm.allAlign,
                "scroll-y": { enabled: false },
                data: _vm.taskListData,
                reserve: true,
                "row-config": { isCurrent: true, isHover: true },
              },
            },
            [
              _c("vxe-column", {
                attrs: { type: "seq", title: "序号", width: "60" },
              }),
              _c("vxe-column", {
                attrs: { field: "displayName", title: "节点名称" },
              }),
              _c("vxe-column", {
                attrs: { field: "operatorName", title: "审批人" },
              }),
              _c("vxe-column", {
                attrs: { field: "operateType", title: "操作类型" },
              }),
              _c("vxe-column", {
                attrs: { field: "approveMsg", title: "审批意见" },
              }),
              _c("vxe-column", {
                attrs: { field: "finishTime", title: "处理时间" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "流程信息",
            visible: _vm.processDialogVisible,
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.processDialogVisible = $event
            },
          },
        },
        [
          _c(
            "vxe-table",
            {
              ref: "xProcess",
              attrs: {
                border: "",
                "show-header-overflow": "",
                "show-overflow": "",
                "column-config": { resizable: true },
                stripe: "",
                round: "",
                loading: _vm.processLoading,
                "max-height": "370",
                align: _vm.allAlign,
                "scroll-y": { enabled: false },
                data: _vm.processListData,
                reserve: true,
                "row-config": { isCurrent: true, isHover: true },
              },
            },
            [
              _c("vxe-column", {
                attrs: { type: "seq", title: "执行顺序", width: "100" },
              }),
              _c("vxe-column", {
                attrs: { field: "displayName", title: "节点名称" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: { title: "选择导出项", width: "400px" },
          model: {
            value: _vm.dialogVisible,
            callback: function ($$v) {
              _vm.dialogVisible = $$v
            },
            expression: "dialogVisible",
          },
        },
        [
          _c(
            "a-radio-group",
            {
              model: {
                value: _vm.ExportItem,
                callback: function ($$v) {
                  _vm.ExportItem = $$v
                },
                expression: "ExportItem",
              },
            },
            [
              _c("a-radio", { attrs: { value: 1 } }, [_vm._v("导出当前页")]),
              _c("a-radio", { attrs: { value: 2, disabled: _vm.disabled } }, [
                _vm._v("导出已选择项"),
              ]),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "vxe-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "vxe-button",
                {
                  attrs: {
                    size: "small",
                    status: "primary",
                    loading: _vm.outExcelButtonLocading,
                  },
                  on: { click: _vm.exportXlsxFun },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "批量审批信息",
            visible: _vm.batchApproveDialogVisible,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.batchApproveDialogVisible = $event
            },
            cancel: function ($event) {
              _vm.batchApproveDialogVisible = false
            },
          },
        },
        [
          _c("el-input", {
            attrs: {
              type: "textarea",
              placeholder: "请输入审批意见",
              maxlength: "300",
              "show-word-limit": "",
            },
            model: {
              value: _vm.batchApproveMsg,
              callback: function ($$v) {
                _vm.batchApproveMsg = $$v
              },
              expression: "batchApproveMsg",
            },
          }),
          _vm.batchApproveValFalse
            ? _c("span", { staticStyle: { color: "red" } }, [
                _vm._v("审批意见不能为空"),
              ])
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "vxe-button",
                {
                  attrs: {
                    status: "primary",
                    loading: _vm.batchApproveBtnLoading,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.approveBatch()
                    },
                  },
                },
                [_vm._v("同意")]
              ),
              _c(
                "vxe-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.batchApproveDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }